export const API_ENDPOINTS = {
  login: {
    loginEmployee: () => `users/auth/login`,
  },
  refresh: {
    refreshToken: () => `users/auth/refresh`,
  },
  forgotPassword: {
    forgotPassword: (empId) => `/forgot-password/getEmailId?empId=${empId}`,
  },
  forgotPasswordMail: {
    forgotPasswordMail: () => `/forgot-password`,
  },
  resetPassword: {
    resetPassword: () => `/forgot-password/change-Password`,
  },
  microsoftLogin: {
    microsoftLogin: () => `/users/microsoft/login`,
  },
  googleLogin: {
    googleLogin: () => `users/google/login`,
  },
  logout: {
    logout: () => `users/auth/logout`,
  },
  refreshTokenCheck: {
    refreshTokenCheck: () => `/refresh-auth`,
  },
};
